<script lang="ts">
import { h, resolveComponent, defineComponent, type VNode } from 'vue';
export default defineComponent({
  name: 'AppTooltip',

  // `class` / `style` style the visible trigger (the icon, or the slot's activator), not the tooltip popup;
  // the other attrs (max-width, open-delay, …) are VTooltip's
  inheritAttrs: false,

  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'mdi-information-outline',
    },
    bottom: {
      type: Boolean,
      default: true,
    },
    wrap: Boolean,
  },

  render (): VNode {
    const { text, icon, bottom, wrap } = this.$props;
    const { class: triggerClass, style: triggerStyle, ...tooltipAttrs } = this.$attrs;
    const VTooltip = resolveComponent('v-tooltip');
    const VIcon = resolveComponent('v-icon');

    return h(VTooltip, {
      ...tooltipAttrs,
      location: bottom ? 'bottom' : undefined,
      class: 'app-tooltip',
    }, {
      activator: ({ props }: any) => {
        if (this.$slots.default) {
          // the slot binds `props` onto its own activator, so the caller's class / style land there too
          return this.$slots.default({ props: { ...props, class: triggerClass, style: triggerStyle } });
        }

        return h(VIcon, {
          ...props,
          class: ['cursor-pointer app-tooltip__icon', triggerClass],
          style: triggerStyle,
        }, { default: () => icon });
      },
      default: () => [
        h('span', { class: `app-tooltip__text ${wrap ? 'app-tooltip__text--wrap' : ''}`.trim() }, text),
      ],
    });
  }
})
</script>
